// @flow
import moment from 'moment-timezone';
import find from 'ramda/es/find';
import keys from 'ramda/es/keys';

import * as activityTypes from './activity-types';
import { getEvents, type ActivityEvents } from './activity-events';


type ActivityType = $Values<typeof activityTypes>

const pathnameParser = (events: ActivityEvents) => {
  let currentTrigger: null | string = null; // uuid или ничего
  const eventKeys = keys(events);
  const updateCurrentTrigger = (currentKey: string) => {
    currentTrigger = events[currentKey].uuid;
    localStorage.setItem(currentKey, moment().format('YYYY-MM-DD'));
    return currentTrigger;
  };

  // сам activity parser
  return (pathname: string): null | string => {
    // встречается ли в текущем пути, определенный путь из eventKeys
    const currentKey = find(key => pathname.includes(key), eventKeys);
    // если не встречается, возвращаем текущий currentTrigger
    if (!currentKey) {
      return currentTrigger;
    }
    // Встречается:
    // есть ли запись по этому пути в localStorage
    const date = localStorage.getItem(currentKey);
    if (!date) {
      // если нет, то значит первый раз зашли, обновляем currentTrigger (и localStorage),
      // что приведет к срабатыванию запроса
      return updateCurrentTrigger(currentKey);
    }
    const mDate = moment(date);
    // если запись есть, то проверяем ее формат и если он не верный, то делаем то же самое
    if (!mDate.isValid()) {
      return updateCurrentTrigger(currentKey);
    }
    // запись есть, сверяем дату записи, если день расходится с текущим делаем то же самое
    if (!moment().isSame(date, 'day')) {
      return updateCurrentTrigger(currentKey);
    }
    // по умолчанию ничего не меняем
    return currentTrigger;
  };
};

const emptyParser = (/* :: a?: any */) => null;

const getActivityParser = (activityType: ActivityType) => {
  if (activityType === activityTypes.ACE_FIRST_ACCESS) {
    const events = getEvents((process.env.APP_NAME || process.env.REACT_APP_NAME), activityType);
    if (events) {
      return pathnameParser(events);
    }
  }
  return emptyParser;
};

export default getActivityParser;
